var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-remote-monitoring-indicators-view',{attrs:{"indicator-id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }